"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSpeakers = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const helpers_1 = require("../chat/helpers");
const addAdmins_1 = require("../chat/addAdmins");
const addSpeakers = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { spaceId, speakers, signer = null, env = (_a = options === null || options === void 0 ? void 0 : options.env) !== null && _a !== void 0 ? _a : constants_1.default.ENV.PROD, pgpPrivateKey = (_b = options === null || options === void 0 ? void 0 : options.pgpPrivateKey) !== null && _b !== void 0 ? _b : null, } = options;
    const group = yield (0, addAdmins_1.addAdmins)({
        chatId: spaceId,
        admins: speakers,
        signer: signer,
        env: env,
        pgpPrivateKey: pgpPrivateKey,
    });
    return (0, helpers_1.groupDtoToSpaceDtoV2)(group, env);
});
exports.addSpeakers = addSpeakers;
//# sourceMappingURL=addSpeakers.js.map